import { StyleSheet, Platform } from 'react-native';

import { Fonts } from '../Themes';

export default StyleSheet.create({
  background: theme => ({
    backgroundColor: theme.colors.backgroundColorSeven,
    height: 700,
    alignSelf: 'center',
    borderRadius: 12.5,
  }),
  icon: {
    alignSelf: 'center',
    marginTop: 171,
  },
  text: theme => ({
    fontSize: Platform.OS === 'ios' ? 16.6 : 16,
    lineHeight: 18.8,
    textAlign: 'center',
    marginHorizontal: 25,
    fontFamily: Fonts.type.VFFont,
    color: theme.colors.textColorTwo,
    marginTop: 11.3,
    marginBottom: 23,
  }),
  tryButton: {
    alignSelf: 'center',
    marginTop: 16,
    flexDirection: 'row',
    alignItems: 'center',
  },
  txtButton: theme => ({
    color: theme.colors.activeTabColor,
    fontSize: Platform.OS === 'ios' ? 14.6 : 14,
  }),
  iconButton: {
    marginLeft: 5,
    marginTop: -4,
    alignItems: 'center',
  },
});
